import industryConfig from "wwg-utilities/dist/config/industryConfig";
import project from "./project";

const careerFields = industryConfig[project].careerFields;

export default careerFields;